// Register.js
import React, { useState } from 'react';
import { useRegisterUserMutation } from '../state/api';
import styles from "./styles.module.css";
import { useNavigate } from "react-router-dom";
import { auth } from "../firebase"
import { createUserWithEmailAndPassword } from 'firebase/auth';

function Register() {
    const [name, setName] = useState('');
    const [profilePic, setProfilePic] = useState('default');
    const [phoneNumber, setPhoneNumber] = useState('');
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [registerUser, { isError, error }] = useRegisterUserMutation();
    const navigate = useNavigate();
    const [errors, setErrors] = useState({});
    const [verificationSent, setVerificationSent] = useState(false);

    const validate = () => {
        const newErrors = {};

        // Name validation
        if (!name.trim()) {
            newErrors.name = "Name is required.";
        }

        // Phone Number validation (basic, you can expand on this)
        const phoneRegex = /^\+?\d{10,15}$/; // Example regex
        if (!phoneRegex.test(phoneNumber)) {
            newErrors.phoneNumber = "Phone number is not valid.";
        }

        // Password validation
        if (password.length < 8) {
            newErrors.password = "Password must be at least 8 characters long.";
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0; // returns true if no errors
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!validate()) {
            return;
        }
        
        const newUser = {
            profilePic,
            name,
            phoneNumber,
            email,
            password,
        };
        try {
            const userCredential = await createUserWithEmailAndPassword(auth, email, password);
            const user = userCredential.user;
            await registerUser(newUser).unwrap();
            await user.sendEmailVerification();
            setVerificationSent(true);
            navigate('/login');
        } catch (err) {
            // Handle error during registration
        }
    };

    return (
        <div>
            <div className={styles.register_container}>
                <form className={styles.register_form_container} onSubmit={handleSubmit}>
                <h2>Cadastro</h2>
                <div className={styles.form_group}>
                    <label>Name: </label>
                    <input 
                        type="text" 
                        value={name} 
                        onChange={(e) => setName(e.target.value)} 
                        required 
                    />
                </div>
                <div className={styles.form_group}>
                    <label>Telefone: </label>
                    <input 
                        type="phoneNumber" 
                        value={phoneNumber} 
                        onChange={(e) => setPhoneNumber(e.target.value)} 
                        required 
                    />
                </div>
                <div className={styles.form_group}>
                    <label>Email: </label>
                    <input 
                        type="email" 
                        value={email} 
                        onChange={(e) => setEmail(e.target.value)} 
                        required 
                    />
                </div>
                <div className={styles.form_group}>
                    <label>Password: </label>
                    <input 
                        type="password" 
                        value={password} 
                        onChange={(e) => setPassword(e.target.value)} 
                        required 
                    />
                </div>
                {verificationSent && (
                    <div className="alert">
                    Verification email sent. Please check your inbox.
                    </div>
                )}    
                {errors.name && <p className={styles.error}>{errors.name}</p>}
                {errors.phoneNumber && <p className={styles.error}>{errors.phoneNumber}</p>}
                {errors.password && <p className={styles.error}>{errors.password}</p>}    
                <button className={styles.register_btn} type="submit">Enviar</button>
            </form>
        </div>
        {isError && <p>{error.message}</p>}
        </div>
    );
}

export default Register;
